import { render, staticRenderFns } from "./PriceAreaTheme1.vue?vue&type=template&id=695604a2&scoped=true"
import script from "./PriceAreaTheme1.vue?vue&type=script&lang=js"
export * from "./PriceAreaTheme1.vue?vue&type=script&lang=js"
import style0 from "./PriceAreaTheme1.vue?vue&type=style&index=0&id=695604a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695604a2",
  null
  
)

export default component.exports